import firebase from "firebase/app";
import 'firebase/firestore'
import 'firebase/auth'
import 'firebase/storage'

const firebaseConfig = {
  apiKey: "AIzaSyBpV2H_7yzAlpkL_A2em7P0S-8_PCKDGWM",
  authDomain: "tasker-49ef0.firebaseapp.com",
  projectId: "tasker-49ef0",
  storageBucket: "tasker-49ef0.appspot.com",
  messagingSenderId: "312236928426",
  appId: "1:312236928426:web:5ba5ce2d065b058297cfd3"
};

  //inti firebase
  firebase.initializeApp(firebaseConfig )

  //init service
  const projectFirestore = firebase.firestore()
  const projectAuth = firebase.auth()
  const projectStorage = firebase.storage()

  //timestamp
  const timestamp = firebase.firestore.Timestamp


  export { projectFirestore, projectAuth, projectStorage, timestamp }